import Model from '@/models/Model.js';

export default class CourseGroup extends Model {
    static entity = 'course_group';

    static modelName = 'CourseGroup';

    static primaryKey = ['course_id', 'group_id'];

    static fields() {
        return {
            id: this.attr(null),
            course_id: this.attr(null),
            group_id: this.attr(null),

            ...super.fields(),

            course: this.belongsTo('courses', 'course_id'),
            group: this.belongsTo('groups', 'group_id'),
        };
    }
}
